var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle",class:{ enabled: _vm.enabled },on:{"click":_vm.toggle}},[_c('div',{staticClass:"toggle-label"},[_vm._t("default",[_vm._v(" label ")])],2),(_vm.enabled)?_c('i',{staticClass:"fas fa-check"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }